<template>
  <!-- 用户管理-老用户查询--->
  <div class="old_users-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model.trim="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model.trim="query.pid" placeholder="上级id"></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-select
            v-model="query.is_normal_rebate"
            @change="getData(1)"
            placeholder="是否正常返利"
          >
            <el-option :value="undefined">全部</el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
        <el-form-item label="老用户返利比例">
          <el-input
            v-model.trim="formData.rebate_ratio"
            placeholder="请输入比例"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit()">保存</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item> -->
      </el-form>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-left: 20px">
          <el-input
            v-model.trim="real_name_user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clear">清除实名验证</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-input
            v-model.trim="primary_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clearPrimary">清除主号</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-input
            v-model.trim="promote_user_code"
            placeholder="请输入用户推广码"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryUser">查询用户</el-button>
        </el-form-item>
        <el-form-item>
          <span v-if="promote_user_id"
            >用户id：{{
              promote_user_id != -1 ? promote_user_id : "无用户"
            }}</span
          >
        </el-form-item>

        <el-form-item style="margin-left: 20px">
          <el-input
            v-model.trim="drop_line_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="dropLine">用户掉线</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload
            accept=".xls,.xlsx"
            :show-file-list="false"
            :on-success="onSuccess"
            :on-error="onError"
            style="display: inline-flex; margin-right: 10px"
            :action="action"
            :headers="headers"
          >
            <el-button size="small" type="primary" icon="el-icon-upload2">
              用户批量掉线-上传表(.xls/.xlsx)
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
        @sort-change="changLine"
      >
        <el-table-column prop="id" label="用户id" align="center">
        </el-table-column>
        <el-table-column label="用户名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="pid"
          label="上级"
          align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column label="是否正常返利" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.is_normal_rebate != 0">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="anchors_rebate" label="返利比例" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="注册时间" align="center">
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        class="underBar"
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page || 15"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getData, getApiData, patchData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'

export default {
  components: {
  },
  data() {
    return {
      dialogVisible: false,//弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        user_id: undefined,//用户id
        pid: undefined,//上级id
        pid_order: 'asc',//排序
      },
      formData: {
        rebate_ratio: ""
      },
      dialogInfo: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
      real_name_user_id: undefined,//清除实名认证uid
      promote_user_code: undefined,//用户推广码
      promote_user_id: undefined,//查询出的推广用户的uid
      primary_id: undefined,//清除主号uid
      drop_line_id: undefined,//需要掉线的用户id
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}user_freeze_import`
    }
  },
  created() {
    this.getData()
    this.getProportionData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('user_bind_old_superior', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getProportionData() {
      //获取返利比例
      getApiData('user_anchors_rebate_setting').then(res => {
        if (res) {
          this.formData.rebate_ratio = res.rebate_ratio
        }
      })
    },
    submit() {
      //保存返利比例
      let params = this.formData
      patchApiData('user_anchors_rebate_setting', params).then((res) => {
        this.$message.success("保存成功")
        //刷新数据
        this.getProportionData()
        this.getData()
      })
    },
    changLine(column, prop, order) {
      if (prop == "pid") {
        switch (order) {
          case 'ascending': this.query.pid_order = 'asc'; break;
          case 'descending': this.query.pid_order = 'desc'; break;
          default: this.query.pid_order = 'asc';
        }
        this.getData(1)//刷新数据
      }
    },
    clear() {
      //清除实名认证
      if (!this.real_name_user_id) {
        return
      }
      this.$confirm('确定要清除实名认证吗？', {
        type: 'warning'
      }).then(res => {
        let params = {
          user_id: this.real_name_user_id
        }
        patchData(`clear_user_id_card`, params)
          .then(
            res => {
              if (res.code) {
                this.$message.success(res.msg)
              } else {
                this.$message.error(res.msg)
              }
            }
          )
          .finally(() => {
          })
      })
    },
    clearPrimary() {
      //清除主号
      if (!this.primary_id) {
        return
      }
      this.$confirm('确定要清除主号吗？', {
        type: 'warning'
      }).then(res => {
        let params = {
          user_id: this.primary_id
        }
        patchData(`clear_major`, params)
          .then(
            res => {
              if (res.code) {
                this.$message.success(res.msg)
              } else {
                this.$message.error(res.msg)
              }
            }
          )
          .finally(() => {
          })
      })
    },
    queryUser() {
      //查询用户
      let params = {
        code: this.promote_user_code
      }
      getApiData(`code_of_user`, params)
        .then(
          res => {
            if (res) {
              this.promote_user_id = res
            } else {
              //无用户时
              this.promote_user_id = -1
            }
          }
        )
        .finally(() => {
        })
    },
    // 设置用户掉线
    dropLine() {
      let params = {
        user_id: this.drop_line_id
      }
      postApiData(`user_freeze_set`, params)
        .then(
          res => {
            if (res.code) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }
        )
        .finally(() => {
        })
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
    handleExport() {
      this.buttonLoading = true

      http
        .get(
          api + '',
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.vip_log-box {
  header {
  }

  .body-box {
  }
}
</style>